export class LeagueConfigError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LeagueConfigError';
  }
}
